// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Oyi1g","col":"styles_col__3gaCd"};